module.exports = __webpack_public_path__ + "static/media/gro_flo_wor_rou.b09167f0.png";